 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"Stack~app-account~app-contact~app-stacks~paywall~stack-add-modal~stack-create-modal~stack-delete-mod~6f76cf9b":"Stack~app-account~app-contact~app-stacks~paywall~stack-add-modal~stack-create-modal~stack-delete-mod~6f76cf9b","Stack~app-account~app-stacks~app-visionaries~auth~stack-create-modal~stack-edit-modal":"Stack~app-account~app-stacks~app-visionaries~auth~stack-create-modal~stack-edit-modal","app-account~app-category~app-home~app-stacks~auth":"app-account~app-category~app-home~app-stacks~auth","app-account":"app-account","app-stacks":"app-stacks","stack-create-modal":"stack-create-modal","stack-edit-modal":"stack-edit-modal","app-contact":"app-contact","paywall":"paywall","stack-add-modal":"stack-add-modal","stack-delete-modal":"stack-delete-modal","auth":"auth","app-visionaries":"app-visionaries","app-about":"app-about","app-aboutaudio":"app-aboutaudio","app-category":"app-category","app-home":"app-home","app-card":"app-card","app-explore":"app-explore","app-helphome":"app-helphome","app-menu":"app-menu","help-tooltip":"help-tooltip","terms":"terms","new-member-welcome":"new-member-welcome","AudioCard~AudioStack":"AudioCard~AudioStack","AudioCard":"AudioCard","AudioStack":"AudioStack","Card":"Card","PremiumErrorCard":"PremiumErrorCard","Stack":"Stack"}[chunkId]||chunkId) + "." + {"Stack~app-account~app-contact~app-stacks~paywall~stack-add-modal~stack-create-modal~stack-delete-mod~6f76cf9b":"4a3503cf","Stack~app-account~app-stacks~app-visionaries~auth~stack-create-modal~stack-edit-modal":"1c157414","app-account~app-category~app-home~app-stacks~auth":"3a84ff8a","app-account":"9febb952","app-stacks":"58e5e2a5","stack-create-modal":"77d98021","stack-edit-modal":"a270712a","app-contact":"5c71b0fc","paywall":"b247cc6b","stack-add-modal":"00d3f13b","stack-delete-modal":"6ab86dcd","auth":"59e732e1","app-visionaries":"08ab57d3","app-about":"241b4377","app-aboutaudio":"35cc563f","app-category":"0c93d539","app-home":"087efd96","app-card":"1aff426e","app-explore":"ed3c3266","app-helphome":"f2697827","app-menu":"4fc10a0b","chunk-746181d0":"0b3b32d7","chunk-76754fc6":"b28e1c37","help-tooltip":"ce26de20","terms":"0b14d9a4","new-member-welcome":"2a4f530a","AudioCard~AudioStack":"c6879db5","AudioCard":"3c59fe57","AudioStack":"051004bf","Card":"cb9175d4","PremiumErrorCard":"ac09e1c9","Stack":"86579d0b"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"Stack~app-account~app-contact~app-stacks~paywall~stack-add-modal~stack-create-modal~stack-delete-mod~6f76cf9b":1,"Stack~app-account~app-stacks~app-visionaries~auth~stack-create-modal~stack-edit-modal":1,"app-account~app-category~app-home~app-stacks~auth":1,"app-account":1,"app-stacks":1,"stack-create-modal":1,"stack-edit-modal":1,"app-contact":1,"paywall":1,"stack-add-modal":1,"auth":1,"app-visionaries":1,"app-about":1,"app-aboutaudio":1,"app-category":1,"app-home":1,"app-card":1,"app-explore":1,"app-helphome":1,"app-menu":1,"help-tooltip":1,"terms":1,"new-member-welcome":1,"AudioCard~AudioStack":1,"AudioStack":1,"Card":1,"PremiumErrorCard":1,"Stack":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"Stack~app-account~app-contact~app-stacks~paywall~stack-add-modal~stack-create-modal~stack-delete-mod~6f76cf9b":"Stack~app-account~app-contact~app-stacks~paywall~stack-add-modal~stack-create-modal~stack-delete-mod~6f76cf9b","Stack~app-account~app-stacks~app-visionaries~auth~stack-create-modal~stack-edit-modal":"Stack~app-account~app-stacks~app-visionaries~auth~stack-create-modal~stack-edit-modal","app-account~app-category~app-home~app-stacks~auth":"app-account~app-category~app-home~app-stacks~auth","app-account":"app-account","app-stacks":"app-stacks","stack-create-modal":"stack-create-modal","stack-edit-modal":"stack-edit-modal","app-contact":"app-contact","paywall":"paywall","stack-add-modal":"stack-add-modal","stack-delete-modal":"stack-delete-modal","auth":"auth","app-visionaries":"app-visionaries","app-about":"app-about","app-aboutaudio":"app-aboutaudio","app-category":"app-category","app-home":"app-home","app-card":"app-card","app-explore":"app-explore","app-helphome":"app-helphome","app-menu":"app-menu","help-tooltip":"help-tooltip","terms":"terms","new-member-welcome":"new-member-welcome","AudioCard~AudioStack":"AudioCard~AudioStack","AudioCard":"AudioCard","AudioStack":"AudioStack","Card":"Card","PremiumErrorCard":"PremiumErrorCard","Stack":"Stack"}[chunkId]||chunkId) + "." + {"Stack~app-account~app-contact~app-stacks~paywall~stack-add-modal~stack-create-modal~stack-delete-mod~6f76cf9b":"b9508b01","Stack~app-account~app-stacks~app-visionaries~auth~stack-create-modal~stack-edit-modal":"e6bdb3a4","app-account~app-category~app-home~app-stacks~auth":"7f1adf9e","app-account":"77faffb4","app-stacks":"fcccc0fd","stack-create-modal":"52fb822a","stack-edit-modal":"522eb168","app-contact":"fc71179e","paywall":"4a618c73","stack-add-modal":"aed4e8d5","stack-delete-modal":"31d6cfe0","auth":"fc3d9fe2","app-visionaries":"57c67b02","app-about":"e93520e0","app-aboutaudio":"da8f2549","app-category":"d32769bf","app-home":"c0b379de","app-card":"c6b88555","app-explore":"59356b6f","app-helphome":"86a657a5","app-menu":"a88db4c0","chunk-746181d0":"31d6cfe0","chunk-76754fc6":"31d6cfe0","help-tooltip":"fa7b9557","terms":"8e4f45ed","new-member-welcome":"0e433876","AudioCard~AudioStack":"4d387ad8","AudioCard":"31d6cfe0","AudioStack":"a137d2ee","Card":"85b2ea36","PremiumErrorCard":"da8f2549","Stack":"a391ef5f"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
